"use client";

import React, { useState } from "react";
import { discussionsApi } from "@/lib/api/services/discussions.api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, Save, Loader2, MessageSquare } from "lucide-react";
import Link from "next/link";
import { toast } from "@/components/ui/toast";

export default function DiscussionsCreatePage() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!title.trim() || !content.trim()) {
      toast({ type: "error", title: "Validation Error", message: "Title and content are required." });
      return;
    }
    setIsSaving(true);
    try {
      await discussionsApi.create({ title, content });
      toast({ type: "success", title: "Discussion created", message: "Your discussion has been posted." });
      setTitle("");
      setContent("");
    } catch {
      toast({ type: "error", title: "Error", message: "Failed to create discussion. Please try again." });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" asChild>
          <Link href="/discussions">
            <ArrowLeft className="mr-2 h-4 w-4" /> Back
          </Link>
        </Button>
      </div>

      <h1 className="text-2xl font-bold text-foreground">Start Discussion</h1>

      <Card>
        <CardContent className="p-6 space-y-4">
          <div>
            <label htmlFor="discussion-title" className="block text-sm font-medium text-foreground mb-1">Title</label>
            <input
              id="discussion-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground"
              placeholder="Enter discussion title"
            />
          </div>
          <div>
            <label htmlFor="discussion-content" className="block text-sm font-medium text-foreground mb-1">Content</label>
            <textarea
              id="discussion-content"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              rows={10}
              className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground"
              placeholder="Share your thoughts"
            />
          </div>
          <Button onClick={handleSave} disabled={isSaving}>
            {isSaving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />}
            Post Discussion
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}